// extracted by mini-css-extract-plugin
export default {"label":"label__EAiG9GVt","subLabel":"subLabel__ZPf_nefG","input":"input__A98uLxMV","moreInfo":"more-info__dGWxhzKk","errorInfo":"error-info__lc3Gxdjs"};